import React from "react";
// import "bootstrap-icons/font/bootstrap-icons.css";

const PrivacyPolicy = () => {
  return (
    <div>
 
      <section className="section-padding-100">
        <div className="container">

          <div className="privacy-content">

            <h4>1. Information We Collect</h4>
            <p>
              Me Loans collects personal information such as your name, contact details,
              income details, employment information, identification documents, and 
              other relevant financial data when you apply for a loan or use our services.
            </p>

            <h4>2. How We Use Your Information</h4>
            <p>
              The information collected is used to process loan applications, verify
              your identity, assess eligibility, improve our services, and comply with
              regulatory requirements. We may also use your details to communicate
              important updates regarding your application or account.
            </p>

            <h4>3. Information Sharing</h4>
            <p>
              Me Loans may share your information with partner banks, NBFCs, credit
              bureaus, and regulatory authorities strictly for loan processing and
              compliance purposes. We do not sell or rent your personal data to
              third parties for marketing purposes.
            </p>

            <h4>4. Data Security</h4>
            <p>
              We implement appropriate technical and organizational measures to
              protect your data against unauthorized access, misuse, or disclosure.
              However, no online transmission is completely secure, and users are
              encouraged to exercise caution while sharing sensitive information.
            </p>

            <h4>5. Cookies & Tracking Technologies</h4>
            <p>
              Our website may use cookies and similar technologies to enhance user
              experience, analyze website traffic, and improve functionality. You
              may choose to disable cookies through your browser settings.
            </p>

            <h4>6. Your Rights</h4>
            <p>
              You have the right to access, update, or request deletion of your
              personal information, subject to applicable laws and regulatory
              requirements.
            </p>

            <h4>7. Policy Updates</h4>
            <p>
              Me Loans reserves the right to update this Privacy Policy at any time.
              Changes will be posted on this page with the revised effective date.
            </p>

            <h4>8. Contact Us</h4>
            <p>
              If you have any questions regarding this Privacy Policy or how your
              data is handled, please contact our support team through the Contact Us page.
            </p>

          </div>

        </div>
      </section>


      <style>{`
        .privacy-content h4 {
          margin-top: 25px;
          font-weight: 600;
        }

        .privacy-content p {
          margin-top: 10px;
          line-height: 1.7;
          color: #555;
        }

        .badge {
          background-color: #1fa5a9;
          padding: 8px 15px;
          font-size: 14px;
        }
      `}</style>

    </div>
  );
};

export default PrivacyPolicy;
